/* eslint-disable max-len */
import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a messages icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <MessagesIcon width={12} />
 */
const MessagesIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M13.983,21,4,30.988V12a3.991,3.991,0,0,1,.1-.877ZM43.9,11.129l-9.883,
            9.883L44,31V12A3.97,3.97,0,0,0,43.9,11.129ZM29.159,25.868a7.291,7.291,0,0,
            1-10.312,0l-2.036-2.036L4.059,36.585A3.989,3.989,0,0,0,8,40H40a3.989,3.989,
            0,0,0,3.94-3.408L31.187,23.84ZM19.64,21l2.036,2.036a3.372,3.372,0,0,0,4.655,
            0l2.028-2.028,2.828-2.828L41.176,8.2A3.957,3.957,0,0,0,40,8H8a3.958,3.958,0,
            0,0-1.17.194l9.981,9.982Z`}
        />
    </SvgIcon>
)

MessagesIcon.defaultProps = defaultProps

export { MessagesIcon }
